import { message } from "antd";
import Joi from "joi-browser";
import { useMemo, useState } from "react";
import { putTTSSettings } from "../../service";
import Form from "V2.0/components/Form";

interface AzureTTS {
  speechRate: string;
}

const template = [
  {
    name: "speechRate",
    label: "Speed",
    description: "Controls the speed of the generated speech",
    type: "slider",
    min: -50,
    max: 50,
    step: 5,
  },
];

const schema = {
  speechRate: Joi.number(),
};

function parsePercentage(percentage) {
  // Regex to capture the sign (optional) and number
  const regex = /^([+-]?)(\d+)(?:\.\d+)?%$/;
  const match = percentage.match(regex);

  if (match) {
    // If match is found, return the number with the correct sign
    const sign = match[1] === "-" ? -1 : 1;
    const number = parseInt(match[2], 10);
    return sign * number;
  }

  return 0;
}

function getAzurettsConfigurableSettings(settings) {
  const { speechRate } = settings;

  const parsedSpeechRate = parsePercentage(speechRate);

  return {
    speechRate: parsedSpeechRate,
  };
}

function AzureTTS(props) {
  const {
    azurettsSettings,
    ttsServiceProvider,
    syncAssistant,
    workspaceId,
    assistantId,
    onClose,
  } = props;

  const [loading, setLoading] = useState(false);
  const [errorMessage] = useState({});

  const inputField = useMemo(() => {
    return getAzurettsConfigurableSettings(azurettsSettings);
  }, [azurettsSettings]);

  const handleSaveSettings = async (data) => {
    setLoading(true);
    message.loading("Saving");

    const updatedSpeechRate =
      data.speechRate > 0
        ? `+${data.speechRate}.00%`
        : `${data.speechRate}.00%`;
    const payload = {
      ttsServiceProvider,
      azurettsSettings: {
        speechRate: updatedSpeechRate,
      },
    };

    try {
      const response = await putTTSSettings({
        workspaceId,
        assistantId,
        payload,
      });

      if (response.status === 200) {
        message.destroy();
        setLoading(false);
        message.success("Saved");
        syncAssistant((prevAssistant) => {
          return { ...prevAssistant, ttsSettings: response.data };
        });
        onClose();
      }
    } catch (e) {
      setLoading(false);

      message.destroy();
      message.error(e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to save settings");
    }
  };

  return (
    <div>
      <Form
        inputField={inputField}
        template={template}
        schema={schema}
        buttonInfo={{ label: "Save", style: "right-side" }}
        loading={loading}
        setLoading={setLoading}
        onSubmit={handleSaveSettings}
      />
    </div>
  );
}

export default AzureTTS;
